import React, { Component } from 'react';
import { HashRouter, Route, Switch} from 'react-router-dom';

import MainTemplate from "./components/mainLayout/template/mainTemplate";
import login from "./components/login/login";
import notFound from "./components/notFound/notFound";
import home from "./components/home/home";
import dashboardSanzione from "./components/dashboard/dashboardSanzione/dashboardSanzione";
import dashboardMappature from "./components/dashboard/dashboardMappature/dashboardMappature";
import detailSanzione from "./components/detail/detailSanzione/detailSanzione";
import Workinprogress from './components/notFound/workinprogress';
import ProtectedRoute from "./common/protectedRoute/protectedRoute";
import ProtectedRouteAdmin from "./common/protectedRoute/protectedRouteAdmin";
import {ProtectedRouteKeyHelp, ProtectedRouteKeyMappatura} from "./common/protectedRoute/protectedRouteKey";
import Contatti from "./components/contatti/contatti";
import 'bootstrap/dist/js/bootstrap.bundle';
import manageProfile from './components/dashboard/dashboardUser/manageProfile';
import detailUser from './components/detail/detailUser/detailUser';
import detailLoginUser from './components/detail/detailUser/detailLoginUser';
import dashboardIngunzioni from './components/dashboard/dashboardIngunzioni/dashboardIngunzioni'
import Ingiunzione from './components/detail/detailIngiunzione/detailIngiunzione';
import RicercaSanzione from './components/ricercaSanzione/ricercaSanzione';
import RecezionePagamento from './components/ricercaSanzione/RecezionePagamento';
import dashboardAree from './components/dashboard/dashboardAree/dashboardAree';
import dashboardLinee from './components/dashboard/dashboardLinee/dashboardLinee';
import localita from './components/dashboard/dashboardLocalita/dashboardLocalita';
import TipologiaSanzione from './components/dashboard/dashboardTipologiaSanzione/dashboardTipologiaSanzione';
import ImpostazioneSaznione from './components/dashboard/dashboardImpostazioneSaznione/dashboardImpostazioneSaznione'
import dashboardRecidivi from './components/dashboard/dashboardRecidivi/dashboardRecidivi'
import RecuperoCrediti from './components/dashboard/dashboardRecuperoCrediti/dashboardRecuperoCrediti';
import Praxy from './components/notFound/praxy';
import dashboardPayroll from './components/dashboard/dashboardPayroll/dashboardPayroll';
import RicercaSanzioneR from './components/ricercaSanzione/RicercaSanzioneR';
import EsitoPagamento from './components/ricercaSanzione/redirectPagamento/EsitoPagamento';
import EsportaSpacchettatoSanzioni from './components/esportaSpacchettato/EsportaSpacchettatoSanzioni';
import EsportaSpacchettatoIngiunzioni from './components/esportaSpacchettato/EsportaSpacchettatoIngiunzioni'
import Reset from './components/Reset/Reset';
import Terms from './components/terms/Terms';
import RicercaRapida from './components/dashboard/dashboardRicercaRapida/RicercaRapida';

class App extends Component {
   constructor(props){
      super(props);
   }

   componentDidMount(){
      document.title = process.env.REACT_APP_TITLE
   }


   render() { 
      return (
         <HashRouter basename={process.env.PUBLIC_URL}>
            <MainTemplate>
               <Switch>
                  <Route exact path='/' component={login}/>
                  <Route exact path='/login' component={login}/>

                  

                  <ProtectedRoute exact path='/home' component={home}/>
                  <ProtectedRoute exact path='/detailSanzione' component={detailSanzione}/>
                  <ProtectedRoute exact path='/dashboardSanzioni' component={dashboardSanzione}/>
                  <ProtectedRouteKeyMappatura exact path='/dashboardMappature' component={dashboardMappature}/>
                  <ProtectedRoute exact path="/esportaSpacchettatoSanzioni" component={EsportaSpacchettatoSanzioni}/>
                  <ProtectedRoute exact path="/esportaSpacchettatoIngiunzioni" component={EsportaSpacchettatoIngiunzioni}/>
                  
                  <ProtectedRouteAdmin exact path='/manageProfile' component={manageProfile}/>
                  <ProtectedRouteAdmin exact path='/detailProfile' component={detailUser}/>
                  <ProtectedRoute exact path='/profile' component={detailLoginUser}/>

                  <Route exact path='*/ricercaSanzione' component={RicercaSanzioneR}/>
                  <Route exact path='*/responsepagamento' component={EsitoPagamento}/>
                  <Route exact path='*/RecezionePagamento' component={RecezionePagamento}/>
                  
                  <ProtectedRoute exact path='*/ingiunzioni' component={dashboardIngunzioni}/>
                  <ProtectedRoute exact path='*/Ingiunzione' component={Ingiunzione}/>

                  <ProtectedRoute exact path='*/RecuperoCrediti' component={RecuperoCrediti}/>

                  <ProtectedRouteAdmin exact path='*/impostazioneSanzione' component={ImpostazioneSaznione}/>
                  <ProtectedRouteAdmin exact path='*/Aree' component={dashboardAree}/>
                  <ProtectedRouteAdmin exact path='*/Linee' component={dashboardLinee}/>
                  <ProtectedRouteAdmin exact path='*/Localita' component={localita}/>
                  <ProtectedRouteAdmin exact path='*/TipologiaSanzione' component={TipologiaSanzione}/>
                  <ProtectedRoute exact path='*/Recidivi' component={dashboardRecidivi}/>
                  <ProtectedRoute exact path='/RicercaRapida' component={RicercaRapida}/>
                  <ProtectedRouteAdmin exact path='*/Reset' component={Reset}/>
                  
                  
                  <ProtectedRouteKeyHelp exact path='*/contatti' component={Contatti}/>
                  <Route exact path='*/Privacy' component={Praxy}/>
                  <Route exact path='*' component={notFound}/>
               </Switch>
            </MainTemplate>
         </HashRouter>
      );
   }
}
export default App;


{/* <ProtectedRoute exact path='/recidivi' component={Workinprogress}/> */}